import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import AlarmLiveReportGrid from './components/AlarmLiveReportGrid';

function SiteGroupAlarmLiveReportView(props) {
  const { t } = useTranslation();
  return (
    <AppNav flex notFullHeight page="plant" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={t('reports.alarmAndMaintenanceLiveSummary')} />
        <AlarmLiveReportGrid singleSiteGroup />
      </Box>
    </AppNav>
  );
}

export default SiteGroupAlarmLiveReportView;
